import React, { useEffect } from "react";
import "./Top.scss";
import { useTranslation } from "react-i18next";

export default function Top() {
  const { t } = useTranslation();

  function TopEvent() {
    // ✅ Track click event
    if (window.gtag) {
      window.gtag("event", "scroll_to_top", {
        event_category: "navigation",
        event_label: "Top Button",
      });
    }

    // Scroll to top
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, Opera
  }

  // Show/hide button on scroll
  function scrollFunction() {
    const topButton = document.getElementById("topButton");
    if (!topButton) return;

    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      topButton.style.visibility = "visible";
    } else {
      topButton.style.visibility = "hidden";
    }
  }

  // ✅ useEffect pour attacher/détacher les events proprement
  useEffect(() => {
    window.addEventListener("scroll", scrollFunction);
    window.addEventListener("load", scrollFunction);

    return () => {
      window.removeEventListener("scroll", scrollFunction);
      window.removeEventListener("load", scrollFunction);
    };
  }, []);

  return (
    <button onClick={TopEvent} id="topButton" title={t("top.title")}>
      <i className="fas fa-hand-point-up" aria-hidden="true"></i>
    </button>
  );
}
